import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new-07",
  "use": "icon-new-07-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-new-07\">\r\n<g id=\"icon-new-07_Frame 41\">\r\n<path id=\"icon-new-07_Vector 47\" d=\"M3.33301 17.9212L11.2497 8.75444M16.2497 2.50448C12.7775 2.36559 4.87413 5.42125 5.54079 15.4213C9.15198 15.0046 17.2499 11.1711 16.2497 2.50448Z\" stroke=\"currentColor\" stroke-width=\"1.25\" stroke-linecap=\"round\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol